// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import store from './vuex'
import Es6Promise from 'es6-promise'
import 'ol/ol.css'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import './assets/icon/iconfont.css'
import './assets/resetcss.css'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  far
} from '@fortawesome/free-regular-svg-icons'
import {
  fab
} from '@fortawesome/free-brands-svg-icons'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'

import VueClipboard from 'vue-clipboard2'
require('es6-promise').polyfill()
Es6Promise.polyfill()

library.add(fas, far, fab)
Vue.prototype.$http = axios
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.prototype.sapost = function (url, query, succall, failcall) {
  this.$http({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    xhrFields: {
      withCredentials: true
    },
    crossDomain: true,
    data: query,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }]
  }).then(r => {
    if (r.data.ecode === 0) {
      if (succall) {
        succall(r)
      }
    } else {
      if (r.data.ecode === 1011) {
        this.$store.dispatch('logout').then(e => {
          router.push('/login')
        })
      } else {
        succall(r)
      }
    }
  })
}

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  data: function () {
    return {
      URL: 'http://111.202.113.150:8088'
    }
  },
  store,
  components: {
    App
  },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js